var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.895 12.112C.45 8.666-.097 3.99 1.028 2.154A3.5 3.5 0 0 1 3.99.5c1.607 0 1.924 1.061 1.984 1.517l.443 3.309c.109.818-.296 1.479-1.082 1.832a7.4 7.4 0 0 0 1.456 2.06 7.4 7.4 0 0 0 2.061 1.455c.353-.787 1.024-1.183 1.83-1.081l3.31.443c.458.06 1.518.377 1.518 1.983a3.47 3.47 0 0 1-1.478 2.843c-2.192 1.537-7.212.176-10.136-2.749"
})));
export default SvgPhone2;